const e="data:image/svg+xml,%3csvg%20width='16'%20height='16'%20viewBox='0%200%2016%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='8'%20cy='8'%20r='8'%20fill='%230A856A'/%3e%3c/svg%3e";

export { e as default };
//# sourceMappingURL=contact-channels83.js.map
